export class Auth {
  constructor(req, storage) {
    this.req = req;
    this.storage = storage;
  }

  async login({ username, password } = {}) {
    const user = await this.loginApi(username, password);
    this.storage.updateUser(user);
    return user;
  }

  async logout(token) {
    const response = await this.logoutApi(token);
    return response;
  }

  async signup(user) {
    const newUser = await this.signupApi(user);
    return newUser;
  }

  async updateToken(auth_key) {
    const user = await this.updateTokenApi(auth_key);
    return user;
  }

  async updateUser(userData) {
    const user = await this.updateUserApi(userData);
    this.storage.updateUser(user);
    return user;
  }

  async updateAvatar(imageData) {
    const user = await this.avatarUploadApi(imageData);
    this.storage.updateUser(user);
    return user;
  }

  async getUsersList(keyword) {
    const usersList = await this.getUsersListApi(keyword);
    return usersList;
  }

  async loginApi(username, password) {
    try {
      const user = await this.req.axiosRequest({
        method: 'POST',
        url: `${this.req.root}/auth/login`,
        form: {
          username,
          password,
        },
      });
      return user;
    } catch (error) {
      console.log(error);
    }
  }

  async updateTokenApi(auth_key) {
    try {
      const user = await this.req.axiosRequest({
        method: 'POST',
        url: `${this.req.root}/auth/login`,
        form: {
          auth_key,
        },
      });
      return user;
    } catch (error) {
      console.log(error);
    }
  }

  logoutApi(token) {
    return this.req.post({
      url: "/auth/logout",
      form: {
        token,
      },
    });
  }

  signupApi(user) {
    return this.req.axiosRequest({
      method: 'POST',
      url: `${this.req.root}/auth/singup`,
      form: { user: JSON.stringify(user) },
    });
  }

  getUsersListApi(keyword) {
    return this.req.get({
      url: "/auth/userlist",
      params: {
        keyword,
      },
    });
  }

  updateUserApi(userData) {
    return this.req.post({
      url: "/auth/updateuser",
      form: {
        user: JSON.stringify(userData),
      },
    });
  }

  avatarUploadApi(image) {
    return this.req.post({
      url: "/auth/avatar-upload",
      form: {
        image,
      },
    });
  }

  getUserByIdApi(id) {
    return this.req.get({ url: "/auth/getuserbyid", params: { id } });
  }

  getVersion() {
    return this.req.get({ url: "/version" });
  }

  getUserFromStorage(id) {
    return this.storage.getUsersList().find((user) => user.user_id == id);
  }

  saveUserToStorage(saveUser) {
    const usersList = this.storage.getUsersList();
    const userInStorage = usersList.find(
      (user) => user.user_id == saveUser.user_id
    );
    if (!userInStorage) {
      usersList.push(saveUser);
      return saveUser;
    }
    return userInStorage;
  }

  async getUserById(userId) {
    let user = this.getUserFromStorage(userId);

    if (!user) {
      let receivedUser = await this.getUserByIdApi(userId);
      
      if(!receivedUser) return null;

      user = this.getUserFromStorage(userId);
      
      if (!user) {
        this.saveUserToStorage(receivedUser);
        user = receivedUser;
      }
    }

    return user;
  }

  async getToken() {
    const expiryDate = new Date(this.storage.getUser().expirydate);
    const currentDate = new Date();
    let accesstoken = this.storage.getUser().accesstoken;

    /*-- checking if token exists and if it's not expired*/
    if (expiryDate < currentDate || !accesstoken) {
      /*-- If token is expired we send request to server to update it*/
      const user = await this.updateToken(this.storage.getUser().auth_key);
      this.storage.updateUser(user);
      accesstoken = user.accesstoken;
    }

    return accesstoken;
  }

}
